import { useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { BottomModal } from '../../shared/BottomModal';
import config from '../../../config';
import { toast } from 'react-toastify';
import { openTelegramLink } from '../../../utils/openLink';

const configReport = [
  { message: 'Фейк' },
  { message: 'Неприемлемый контент' },
  { message: 'Возраст' },
  { message: 'Оскорбления' },
  { message: 'Поведение вне MYTA' },
  { message: 'Мошенничество или спам' }
];

export function ReportUser({ userId, onTriggerClick }) {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);

  const [isOpen, onClose] = useState(false);
  const [reported, setReported] = useState({
    isReported: false
  });

  const handleSendReportToUser = async (reason, targetUserId) => {
    try {
      await axiosPrivate.post(config.API.USERS.REPORT, {
        targetUserId,
        reason,
        details: ''
      });

      setReported((prev) => ({ ...prev, isReported: true }));
      toast.success('Жалоба отправлена');
    } catch (error) {
      console.log(error);

      const message = error?.response?.data?.message;

      toast.error(message || 'Ошибка при отправке жалобы');
    }
  };

  return (
    <>
      <div
        className="w-full border-b border-[#233636] h-[60px] flex items-center justify-between pl-[16px] pr-[16px]"
        onClick={() => {
          onTriggerClick?.();
          onClose(true);
        }}
      >
        <span>Пожаловаться</span>
        <img src="/icons/report.svg" />
      </div>

      <BottomModal isOpen={isOpen} onClose={onClose}>
        <div className=" text-white overflow-auto mb-6">
          {reported.isReported ? (
            <div className="flex flex-col justify-start items-center w-full mt-[40px]">
              <img src="/icons/report_sent.svg" className="w-[80px] h-[80px]" />
              <p className="text-center w-full mt-[30px] font-semibold text-[22px]">Жалоба отправлена</p>
              <p className="text-center text-[16px] mt-[20px] font-normal pl-2 pr-2">
                Мы проверим её и примем меры. Спасибо, что помогаете делать приложение лучше!
              </p>
            </div>
          ) : (
            <>
              <div className="flex flex-col justify-start items-center w-full">
                <p className="font-semibold text-[22px]">Пожаловаться</p>
                <p className="font-normal text-[16px]">Это останется между нами</p>
              </div>

              <div className="w-full pr-[16px] pl-[16px]">
                {configReport.map(({ message }, index) => (
                  <div
                    className={`h-[60px] flex items-center cursor-pointer ${configReport.length - 1 == index ? '' : 'border-b border-[#6D6D6D]'}`}
                    onClick={() => handleSendReportToUser(message, userId)}
                  >
                    <span>{message}</span>
                  </div>
                ))}
                <div
                  className={`h-[60px] flex items-center border-t border-[#6D6D6D] text-[#A1F69E] gap-1 cursor-pointer`}
                  onClick={() => openTelegramLink('https://t.me/mytadating')}
                >
                  <span>Написать в поддержку</span>
                  <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M-7.53403e-05 5.4082H12.3076M7.30762 0.408203L12.3076 5.4082L7.30762 10.4082"
                      stroke="#A1F69E"
                      stroke-width="1.15385"
                    ></path>
                  </svg>
                </div>
              </div>
            </>
          )}
        </div>
      </BottomModal>
    </>
  );
}
